import { useState, useEffect, useContext } from 'react';
import callContext from '@/pages/crm/callCenter/callManage/callManageContext'
import styles from '../../index.module.less';
import {getlogList, addLogList, clueFollowLogList, clueFollowLogAdd} from '@/services/callCenter'
import { Form, Spin, Input, message, Button,Empty  } from 'antd';
import dayjs from 'dayjs';
import {trimStr} from "@/utils/data.ts";
const { TextArea } = Input;

function FollowUpDiary(props: any) {
  const {  callManageState } = useContext(callContext)
  const { detailParameter, followUpDiaryRefresh } = callManageState;
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [refresh, setRefresh] = useState(false); // 列表刷新
  const [followRecordList, setFollowRecordList] = useState([])
  useEffect(() => {
    getFollowUpRecord();
  }, [detailParameter.id, refresh,followUpDiaryRefresh]);

  // 获取跟进记录数据
  const getFollowUpRecord = () => {
    if (!detailParameter.id || loading) return;
    setLoading(true);
    clueFollowLogList({orderBys:[{columnName: 'ID', asc: false}], clueId: detailParameter.id })
      .then((res: any) => {
        setFollowRecordList(res||[])
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // 提交保存跟进记录
  const onFinish = (values: any) => {
    if (!detailParameter.id) return;
    setSubmitLoading(true);
    clueFollowLogAdd({
      clueId: detailParameter.id,
      content: values.content,
      followType: 'trackPhone',
    })
      .then((res: any) => {
        message.success(res.message || '操作成功');
        form.resetFields();
        setRefresh(!refresh);
      })
      .finally(() => {
        setSubmitLoading(false);
      });
  };
  const listItme = (data: any, index: any) => {
    return (
      <div className={styles.followListItem} key={index}>
        <div className={styles.itemHead}>
          <div className={styles.itemHeadTitle}>
            {data['buttonName']} - <span style={{ fontSize: 12 }}>{data?.createdTime?dayjs(data.createdTime).format('YYYY-MM-DD HH:mm:ss'):''}</span>
          </div>
          <div className={styles.itemHeadTxt}>{data['followerTypeName']}</div>
        </div>
        <div className={styles.itemMain}>
          <div className={styles.itemRow}>
            <div className={styles.itemRowContent}>{data.followerType === 'VIEW_PHONE' ? `【${data.name}】` : ''} {data['content']}</div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className={styles.followUpDiary}>
      <div>
        <div className={styles.followContent}>
          <Form onFinish={onFinish} form={form} layout={'vertical'}>
            <Form.Item label="跟进内容" name="content" rules={[{ required: true, message: '请输入' }]} style={{marginBottom:'6px'}}>
              <TextArea placeholder="请填写跟进内容" allowClear onChange={(e) => form.setFieldValue('content', trimStr(e.target.value))}/>
            </Form.Item>
            <Form.Item className={styles.followSaveBtn}>
              <Button type="primary" loading={submitLoading} disabled={submitLoading} htmlType="submit">
                保存
              </Button>
            </Form.Item>
          </Form>
        </div>
        <div className={styles.followList}>
          <div className={styles.followTitle}>跟进记录</div>
          <Spin tip="Loading" size="small" spinning={loading}>
            {followRecordList.length ? (
              followRecordList.map((d: any, i: any) => listItme(d, i))
            ) : (
              <Empty />
            )}
          </Spin>
        </div>
      </div>
    </div>
  );
}

export default FollowUpDiary;
